import { atom } from "recoil";

export const monthTotalState = atom({
  key: "monthTotalState",
  default: 0,
});
